import { Component, Input, OnChanges, Output, EventEmitter } from '@angular/core';


@Component({
  selector: 'app-pagination',
  templateUrl: './app-pagination.component.html'
})
export class PaginationComponent implements OnChanges {
  @Input() totalRecords: number = 0;
  @Input() recordsPerPage: number = 0;

  @Output() onPageChange: EventEmitter<number> = new EventEmitter();

  public pages: number[] = [];
  public showpages: number[] = [];
  activePage: number;
  length: any = localStorage.getItem("TotalPages");
  loop: number = 0;
  ngOnChanges() {
    debugger;
    this.showpages=[];
    const pageCount = this.getPageCount();
    this.pages = this.getArrayOfPage(pageCount);
    if (this.pages.length >= this.length) {
      for (let i = 1; i <= this.length; i++) {
        this.showpages.push(i);
      }
    }
    else {
      this.showpages = this.pages;
    }
    this.activePage = 1;
    this.onPageChange.emit(1);
  }

  private getPageCount(): number {
    let totalPage: number = 0;
    if (this.totalRecords > 0 && this.recordsPerPage > 0) {
      const pageCount = this.totalRecords / this.recordsPerPage;
      const roundedPageCount = Math.floor(pageCount);
      totalPage = roundedPageCount < pageCount ? roundedPageCount + 1 : roundedPageCount;
    }
    return totalPage;
  }

  private getArrayOfPage(pageCount: number): number[] {
    let pageArray: number[] = [];
    if (pageCount > 0) {
      for (var i = 1; i <= pageCount; i++) {
        pageArray.push(i);
      }
    }
    return pageArray;
  }

  onClickPage(pageNumber: number, action: string) {
    if (pageNumber < 1) return;
    if (pageNumber > this.pages.length) {
      return;
    }
    
    let lastPage = this.showpages[this.showpages.length - 1];
    let firstPage = this.showpages[0];
    debugger;
    if (action == 'next') {
      if (pageNumber > this.showpages.length) {

        this.showpages.push(lastPage+1);
        this.showpages.shift();
      }
    }
    if (action == 'prev') {
      
      if (pageNumber >= this.showpages.length) {
        this.showpages.pop();        
        this.showpages.unshift(firstPage - 1);
      }
      else{
        if(firstPage > 1)
        {         
        this.showpages.pop();
        this.showpages.unshift(firstPage - 1);
        }
      }
    }
    this.activePage = pageNumber;
    this.onPageChange.emit(this.activePage);
  }
}
